/* OESFX — motion + form. Requires GSAP, ScrollTrigger, Lenis (loaded before this file). Handles several .ox sections on one page. */
(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('.ox'));
  if (!roots.length || window.__oxInit) return;
  window.__oxInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasGsap = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';

  /* ---------- statement: wrap words ---------- */
  var stmts = [];
  roots.forEach(function (root) {
    root.querySelectorAll('.stmt').forEach(function (stmt) {
      if (stmt.dataset.split) return;
      var hi = (stmt.dataset.hi || '').split('|').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var words = stmt.textContent.trim().split(/\s+/);
      stmt.innerHTML = words.map(function (w) {
        var clean = w.replace(/[^\w']/g, '').toLowerCase();
        var cls = hi.indexOf(clean) > -1 ? 'wd hi on' : 'wd on';
        return '<span class="' + cls + '">' + w + '</span>';
      }).join(' ');
      stmt.dataset.split = '1';
      stmts.push(stmt);
    });
  });

  /* ---------- hero video: nudge playback ---------- */
  var hv = document.querySelector('.ox .hero video');
  if (hv) {
    var wantMobile = window.matchMedia('(max-width: 700px) and (orientation: portrait)').matches;
    if (wantMobile && hv.dataset.m) {
      hv.pause();
      hv.querySelectorAll('source').forEach(function (s) { s.remove(); });
      hv.dataset.m.split('|').filter(Boolean).forEach(function (u) { var s = document.createElement('source'); s.src = u; s.type = 'video/mp4'; hv.appendChild(s); });
      if (hv.dataset.mp) hv.poster = hv.dataset.mp;
      hv.load();
    }
    var kick = function () { if (hv.paused) { var p = hv.play(); if (p && p.catch) p.catch(function () {}); } };
    document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
    ['touchstart', 'scroll', 'pointerdown'].forEach(function (ev) { window.addEventListener(ev, kick, { once: true, passive: true }); });
    window.addEventListener('load', kick);
  }

  /* ---------- form ---------- */
  var f = document.getElementById('oxform');
  if (f) {
    var msg = document.getElementById('oxmsg'), btn = document.getElementById('oxsend');
    var check = function (el) {
      var wrap = el.closest('.fl'), ok = true;
      if (el.required && !el.value.trim()) ok = false;
      if (ok && el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim())) ok = false;
      if (wrap) wrap.classList.toggle('err', !ok);
      return ok;
    };
    f.querySelectorAll('[required]').forEach(function (el) {
      el.addEventListener('input', function () { check(el); });
      el.addEventListener('blur', function () { check(el); });
    });
    f.addEventListener('submit', function (e) {
      var all = true;
      f.querySelectorAll('[required]').forEach(function (el) { if (!check(el)) all = false; });
      if (!all) {
        e.preventDefault();
        if (msg) msg.classList.add('on');
        var first = f.querySelector('.fl.err input,.fl.err select,.fl.err textarea');
        if (first) first.focus();
        return;
      }
      if (msg) msg.classList.remove('on');
      if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'Sending…'; }
    });
  }

  /* ---------- no motion: show everything ---------- */
  if (reduce || !hasGsap) {
    roots.forEach(function (root) { root.classList.remove('js'); });
    stmts.forEach(function (s) { s.querySelectorAll('.wd').forEach(function (w) { w.classList.add('on'); }); });
    return;
  }
  roots.forEach(function (root) { root.classList.add('js'); });

  /* ---------- smooth scroll ---------- */
  var lenis = null;
  if (typeof Lenis !== 'undefined') {
    lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var el = document.querySelector(id);
        if (!el) return;
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70, duration: 1.3 });
      });
    });
  }
  gsap.registerPlugin(ScrollTrigger);
  var E = 'expo.out';

  roots.forEach(function (root) {
    /* ---------- hero ---------- */
    var hero = root.querySelector('.hero, .phero');
    if (hero) {
      var media = hero.querySelector('.vid video, .vid img');
      var tl = gsap.timeline({ defaults: { ease: E } });
      if (media) tl.to(media, { opacity: 0.78, duration: 1.8, ease: 'power2.out' }, 0);
      tl.to(hero.querySelectorAll('.eyebrow, .kk'), { opacity: 1, y: 0, duration: 1, clearProps: 'transform' }, 0.25);
      tl.to(hero.querySelectorAll('h1 .ln > span'), { y: 0, duration: 1.3, stagger: 0.09 }, 0.35);
      tl.to(hero.querySelectorAll('.sub, .cta, .cue, .ld'), { opacity: 1, y: 0, duration: 1, stagger: 0.08, clearProps: 'transform' }, 0.9);
      if (media && media.tagName === 'VIDEO') gsap.to(media, { yPercent: 10, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      hero.querySelectorAll('.rv').forEach(function (b) { if (!b.classList.contains('pband')) b.classList.remove('rv'); });
    }

    /* ---------- line + fade reveals ---------- */
    root.querySelectorAll('.rv').forEach(function (block) {
      var lines = block.querySelectorAll('.ln > span');
      var fades = block.querySelectorAll('.fu');
      var tl2 = gsap.timeline({ scrollTrigger: { trigger: block, start: 'top 82%', once: true } });
      if (lines.length) tl2.to(lines, { y: 0, duration: 1.2, ease: E, stagger: 0.08 }, 0);
      if (fades.length) tl2.to(fades, { opacity: 1, y: 0, duration: 1, ease: E, stagger: 0.07, clearProps: 'transform' }, 0.15);
    });

    /* ---------- image masks ---------- */
    root.querySelectorAll('.msk').forEach(function (fig, i) {
      var img = fig.querySelector('img');
      gsap.timeline({ scrollTrigger: { trigger: fig, start: 'top 88%', once: true } })
        .to(fig, { clipPath: 'inset(0 0 0% 0)', duration: 1.4, ease: E, delay: (i % 3) * 0.08 }, 0)
        .to(img, { scale: 1, duration: 1.8, ease: E }, 0);
    });

    /* ---------- rules draw in ---------- */
    root.querySelectorAll('.rule').forEach(function (r) {
      gsap.fromTo(r, { scaleX: 0, transformOrigin: 'left center' }, { scaleX: 1, duration: 1.4, ease: E, scrollTrigger: { trigger: r, start: 'top 90%', once: true } });
    });
  });

  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
})();
